
/* eslint-disable */
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  components: { VuePhoneNumberInput },
  data() {
    return {
      registerStep: 1,
      firstStepErrors: [],
      secondStepErrors: [],
      thirdStepErrors: [],
      fourthStepErrors: [],
      associatesArr: [],
      emailErr: null,
      phoneErr: false,

      submitVar: true,
      limit: 1,
      userEmail: null,
      popupSuccess: false,
      infoMail: "",

      // lead
      package: "",
      firstName: "",
      lastName: "",
      email: "",
      notes: "",
      company: "",
      activityTypeID: null,
      packageID: null,
      formattedNumber: null,
      loading: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const body = document.documentElement;
      body.classList.add("try-for-free-page");

      this.$renderRecaptcha("recaptcha-try-for-free");
    });

    this.$watch(
      () => {
        if (this.$refs.registerForm) {
          return this.$refs.registerForm.form.additionalFields.packages;
        }
      },
      (v) => {
        this.package = v;
      }
    );
    this.$watch(
      () => {
        if (this.$refs.registerForm) {
          return this.$refs.registerForm.form.firstName;
        }
      },
      (v) => {
        this.firstName = v;
      }
    );
    this.$watch(
      () => {
        if (this.$refs.registerForm) {
          return this.$refs.registerForm.form.lastName;
        }
      },
      (v) => {
        this.lastName = v;
      }
    );
    this.$watch(
      () => {
        if (this.$refs.registerForm) {
          return this.$refs.registerForm.form.from;
        }
      },
      (v) => {
        this.email = v;
      }
    );

    this.$watch(
      () => {
        if (this.$refs.registerForm) {
          return this.$refs.registerForm.form.additionalFields.company;
        }
      },
      (v) => {
        this.company = v;
      }
    );
  },
  destroyed() {
    const body = document.documentElement;
    body.classList.remove("try-for-free-page");
  },
  watch: {
    value() {
      this.dropdownOpen = false;
    },
  },
  methods: {
    async sendForm() {
      await this.send();
    },
    async send() {
      this.loading = true;
      const obj = {
        status: null,
        rating: null,
        countryIsoCode: this.$i18n.locale,
        category: 30,
        sourceType: 1,
        source: 80,
        products: [{ id: this.packageID, type: "product" }],
        productCategories: [1400],
        poi: this.package,
        tags: [19],
        assignType: "person",
        owner: 231,
        notes: this.notes,
        email: this.email,
        uid: "",
        mobilePhone: this.formattedNumber,
        address: null,
        propertyMedia: [],
        name: this.company,
        industryType: this.activityTypeID,
        nkdCode: null,
        annualBudget: null,
        numberOfEmployees: null,
        contactFirstName: this.firstName,
        contactLastName: this.lastName,
        contactEmail: this.email,
        contactPersonRole: null,
        vat: null,
        website: "",
        companyTags: [19],
        media: [],
        companySubscribers: [],
      };

      await this.$axios({
        url: "/api/v1/lead/company/create/web",
        method: "POST",
        data: { ...obj },
      })
        .then((res) => {
          this.loading = false;
          this.showSuccessPopup();
        })
        .catch((err) => {
          console.log(err);
          if (this.$i18n.locale === "hr") {
            this.$toast.error(
              "Dogodila se greška prilikom slanja poruke, provjerite sva polja i pokušajte ponovno!"
            );
          } else {
            this.$toast.error(
              "There was an error sending your message, please check all fields and try again!"
            );
          }
        });
      this.loading = false;
    },
    showSuccessPopup() {
      window.scrollTo(0, 0);
      this.popupSuccess = true;
    },
    resetPackages(form) {
      form.additionalFields.packages = "";
      this.thirdStepErrors = [];
    },
    getLimit() {
      if (
        this.registerStep === 4 &&
        this.$refs.tryForFreePackages &&
        this.$refs.tryForFreePackages.limit
      ) {
        this.limit = this.$refs.tryForFreePackages.limit;
      }
    },
    setAssociates(form) {
      if (!form) return;
      if (
        this.$refs.associates &&
        this.$refs.associates.associates &&
        this.$refs.associates.associates.length > 0
      ) {
        const associates = this.$refs.associates.associates;
        associates.forEach((associate, index) => {
          // validation

          if (
            associate.email === null &&
            !this.fourthStepErrors.includes(`"associateEmailError${index}"`)
          ) {
            this.fourthStepErrors.push(`"associateEmailError${index}"`);
          } else if (associate.email !== null) {
            this.fourthStepErrors = this.fourthStepErrors.filter(
              (e) => e !== `"associateEmailError${index}"`
            );
          }

          if (
            associate.firstName === "" &&
            !this.fourthStepErrors.includes(`"associateFirstNameError${index}"`)
          ) {
            this.fourthStepErrors.push(`"associateFirstNameError${index}"`);
          } else if (associate.firstName !== "") {
            this.fourthStepErrors = this.fourthStepErrors.filter(
              (e) => e !== `"associateFirstNameError${index}"`
            );
          }

          if (
            associate.lastName === "" &&
            !this.fourthStepErrors.includes(`"associateLastNameError${index}"`)
          ) {
            this.fourthStepErrors.push(`"associateLastNameError${index}"`);
          } else if (associate.lastName !== "") {
            this.fourthStepErrors = this.fourthStepErrors.filter(
              (e) => e !== `"associateLastNameError${index}"`
            );
          }

          if (
            associate.workFunction === null &&
            !this.fourthStepErrors.includes(
              `"associateWorkFunctionError${index}"`
            )
          ) {
            this.fourthStepErrors.push(`"associateWorkFunctionError${index}"`);
          } else if (associate.workFunction !== null) {
            this.fourthStepErrors = this.fourthStepErrors.filter(
              (e) => e !== `"associateWorkFunctionError${index}"`
            );
          }

          if (this.fourthStepErrors && !this.fourthStepErrors.length) {
            this.associatesArr.push(associate);
            form.additionalFields.associates = JSON.stringify(
              this.associatesArr
            );
          } else {
            this.associatesArr.splice(index, 1);
          }
        });
      } else {
        this.fourthStepErrors = [];
      }
    },

    // validate
    validateInfoAnswers(form) {
      this.setAssociates(form);
      // step 1
      if (this.registerStep === 1) {
        this.userEmail = form.from;

        if (!form.firstName) {
          this.firstStepErrors.push("firstNameError");
        } else
          this.firstStepErrors = this.firstStepErrors.filter(
            (e) => e !== "firstNameError"
          );

        if (!form.lastName) {
          this.firstStepErrors.push("lastNameError");
        } else
          this.firstStepErrors = this.firstStepErrors.filter(
            (e) => e !== "lastNameError"
          );

        if (!form.contactNumber) {
          this.firstStepErrors.push("contactPhoneError");
          this.phoneErr = false;
        } else if (this.$refs.phoneNumber && !this.$refs.phoneNumber.isValid) {
          this.firstStepErrors.push("contactPhoneError");
          this.phoneErr = true;
        } else {
          this.firstStepErrors = this.firstStepErrors.filter(
            (e) => e !== "contactPhoneError"
          );
          if (this.$refs.phoneNumber && this.$refs.phoneNumber.phoneFormatted) {
            this.formattedNumber = this.$refs.phoneNumber.phoneFormatted;
          }
        }

        if (
          form.from &&
          form.from.length &&
          /[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}/.test(form.from)
        ) {
          this.emailErr = false;
        } else if (
          form.from &&
          form.from.length &&
          !/[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}/.test(form.from)
        ) {
          this.emailErr = true;
        } else if (!form.from) {
          this.emailErr = false;
        }
        if (!form.from || this.emailErr) {
          this.firstStepErrors.push("contactEmailError");
        } else {
          this.firstStepErrors = this.firstStepErrors.filter(
            (e) => e !== "contactEmailError"
          );

          this.infoMail = form.from;
        }

        if (!form.additionalFields.company) {
          this.firstStepErrors.push("companyError");
        } else
          this.firstStepErrors = this.firstStepErrors.filter(
            (e) => e !== "companyError"
          );

        // if (!form.additionalFields.activity) {
        //   this.firstStepErrors.push("activityError");
        // } else
        //   this.firstStepErrors = this.firstStepErrors.filter(
        //     (e) => e !== "activityError"
        //   );

        // consent
        if (form.acceptedConsents && !form.acceptedConsents.length) {
          this.firstStepErrors.push("consentError");
          this.$toast.error(this.$i18n.t("questionnaire.consentError"));
        } else
          this.firstStepErrors = this.firstStepErrors.filter(
            (e) => e !== "consentError"
          );
      }
      // step 2
      if (this.registerStep === 2) {
        if (!form.content) {
          this.secondStepErrors.push("contentError");
        } else
          this.secondStepErrors = this.secondStepErrors.filter(
            (e) => e !== "contentError"
          );
      }

      // step 3
      if (this.registerStep === 3) {
        if (!form.additionalFields.packages) {
          this.thirdStepErrors.push("packagesError");
        } else {
          this.thirdStepErrors = this.thirdStepErrors.filter(
            (e) => e !== "packagesError"
          );
          this.removeHTMLTags(form);
        }

        form.subject = `"[ZAHTJEV ZA OTVARANJE PAKETA GB]- ${form.firstName}, ${form.lastName}, ${form.additionalFields.company}, ${form.additionalFields.packages}"`;
        this.notes = `""<p>First name: ${this.firstName}<br>\nLast name: ${this.lastName}<br>\nFrom: ${this.email}<br>\nContact number: ${this.formattedNumber} <br>\nSubject: \"${form.subject}\"<br>\nContent: ${form.additionalFields.packages}<br>\ncompany: ${form.additionalFields.company}<br>\nactivity: ${form.additionalFields.activity}<br>\nassociates: ${this.associatesArr} <br>\npackages: ${form.additionalFields.packages}<br></p>"`;

        // get Activity ID
        if (this.$refs.activity && this.$refs.activity.activeActivityID) {
          this.activityTypeID = this.$refs.activity.activeActivityID;
        }

        // get package ID
        if (
          this.$refs.tryForFreePackages &&
          this.$refs.tryForFreePackages.packageID
        ) {
          this.packageID = Number(this.$refs.tryForFreePackages.packageID);
        }
      }

      if (
        (this.registerStep === 1 &&
          this.firstStepErrors &&
          !this.firstStepErrors.length) ||
        (this.registerStep === 2 &&
          this.secondStepErrors &&
          !this.secondStepErrors.length) ||
        (this.registerStep === 3 &&
          this.thirdStepErrors &&
          !this.thirdStepErrors.length)
      ) {
        this.registerStep++;
        window.scrollTo(0, 0);
      }
    },

    returnError(stepError, id) {
      return !!(stepError.length && stepError.includes(id));
    },
    prevStep() {
      this.registerStep--;
      window.scrollTo(0, 0);
    },
    removeHTMLTags(form) {
      if (!form) return;
      if (form.additionalFields && form.additionalFields.packages) {
        const replace = form.additionalFields.packages.replaceAll(
          /<\/?[^>]+(>|$)/gi,
          ""
        );
        form.additionalFields.packages = replace;
      }
    },
    sendMessage(form) {
      this.setAssociates(form);
      if (
        this.firstStepErrors &&
        !this.firstStepErrors.length &&
        this.secondStepErrors &&
        !this.secondStepErrors.length &&
        this.thirdStepErrors &&
        !this.thirdStepErrors.length &&
        this.fourthStepErrors &&
        !this.fourthStepErrors.length
      ) {
        this.submitVar = true;
      } else {
        this.submitVar = false;
        if (this.$i18n.locale === "hr") {
          this.$toast.error("Niste popunili sva polja!");
        } else {
          this.$toast.error("You did not filled in all the fields!");
        }
      }
    },
  },
};
